import React from "react";

/**
 * Render field component
 * @param {*} param0
 */
const RenderField = ({
  input,
  label,
  type,
  className,
  disabled,
  placeholder = { label },
  meta: { touched, error, warning },
}) => (
  <>
    {label && <label>{label}</label>}
    <input
      {...input}
      disabled={disabled}
      placeholder={placeholder}
      type={type}
      className={touched && error ? className + " inf-error" : className}
    />
    {touched &&
      ((error && <span className="input-error">{error}</span>) ||
        (warning && <span className="input-error">{warning}</span>))}
    {input.name && input.name === "businessEmail" && (
      <a
        href="https://www.infince.com/contact-us"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="input-info">Don't have a business email?</span>
      </a>
    )}
  </>
);

export default RenderField;
